import { render, staticRenderFns } from "./vSelectC.vue?vue&type=template&id=aef5c242&scoped=true"
import script from "./vSelectC.vue?vue&type=script&lang=js"
export * from "./vSelectC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef5c242",
  null
  
)

export default component.exports